import { Component, OnInit } from '@angular/core';
import { PasswordReset } from '../../models/password-reset';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router } from '../../../../node_modules/@angular/router';
import { AuthHttpClient } from '../../services/auth-http-service/auth-http.service';
import { Subscription } from '../../../../node_modules/rxjs';
import { LoggingService } from '../../services/logging-service/logging.service';
import { HttpErrorResponse } from '../../../../node_modules/@angular/common/http';
import { MatSnackBar } from '../../../../node_modules/@angular/material';

@Component({
  selector: 'app-portal-reset-password',
  templateUrl: './portal-reset-password.component.html',
  styleUrls: ['./portal-reset-password.component.css']
})
export class PortalResetPasswordComponent implements OnInit {

  passwordReset: PasswordReset;
  resetSubscription: Subscription;
  resetSent: boolean;
  resetting: boolean;

  constructor(private shellUpdateService: ShellUpdateService, private appConfigService: AppConfigService, private router: Router, private authHttp: AuthHttpClient, private loggingService: LoggingService, private snackBar: MatSnackBar) { }

  ngOnInit() {

    // Update the headers and footers
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, null, null, null));

    // Show / Hide certain components such as burger menu etc
    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, false, false, true));

    // Init the password reset
    this.passwordReset = new PasswordReset();
  }

  submitResetPassword() {
    this.resetting = true;
    this.resetSubscription = this.authHttp.post(this.appConfigService.ResetPasswordUrl, this.passwordReset).subscribe(response => {
      this.snackBar.open("Reset request sent. Please check your email", "", { duration: 5000 });
      this.resetSent = true;
    }, (error) => {
      let httpErrorResponse = error as HttpErrorResponse;
      this.resetting = false;
      this.loggingService.log('Error resetting password', this.appConfigService.LogToConsole);
      this.authHttp.deleteToken();
      let snackbarRef;
      switch (httpErrorResponse.status) {
        case 500:
          this.snackBar.open("Server error. Please try again later.", "", { duration: 5000 });
          break;
        default:
          this.snackBar.open("Server unavailable. Please try again later.", "", { duration: 5000 });
          break;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/portal-reset-password/portal-reset-password.component.ts